// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TabProps } from "@insite/mobius/Tab";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xBaseTheme } from "@rpsc/XDL/types";
import { color, styledScrollbar } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.bold,
            lineHeight: "19px",
        },
        css: css`
            border: 0;
            border-radius: 22px;
            background-color: ${color("common.ui2")};
            padding: 12px 20px;
            height: fit-content;
            display: flex;
            cursor: pointer;
            color: ${color("common.black")};
            min-width: unset;
            transition: color 500ms ease;

            &:hover {
                background-color: ${color("common.ui8")};
                color: ${color("common.white")};
                border-bottom: 0;
            }

            ${({ selected }: TabProps) =>
                selected &&
                css`
                    z-index: 1;
                    outline-width: 0;
                    &,
                    &:hover {
                        color: ${color("common.white")};
                        background-color: ${color("common.black")};
                        border-bottom: 0;
                    }
                `}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                border-radius: 25.5px;
                background-color: ${color("common.ui2")};
                width: fit-content;
                & > li:not(:last-child) {
                    margin-right: 12px;
                }
                ${styledScrollbar()}
                position: relative;
                &::after {
                    content: "";
                    width: 100px;
                    border-radius: 25px;
                    height: calc(100% - 8px);
                    background: red;
                    position: absolute;
                    transition: scale 1s, translate 500ms, opacity 500ms;
                    transform-origin: left;
                    right: 0;
                    left: 0;
                    top: 4px; // padding
                    translate: 0;
                    background-color: ${color("common.black")};
                    ${({ left, width }: any) =>
                        left === undefined
                            ? css`
                                  opacity: 0;
                              `
                            : css`
                                  translate: ${left + 1}px;
                                  width: ${width - 2}px;
                                  opacity: 0.5;
                              `}
                }
            `,
            tabContent: css`
                position: relative;
                margin-top: 0;
                padding: 0;
                border: 0;
            `,
            wrapper: css`
                width: 100%;
            `,
        },
    },
} as xBaseTheme["tab"];
